export default "__VITE_ASSET__DxasCwYI__"